require('../modules/es7.global');
module.exports = require('../modules/_core').global;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/global.js
// module id = 3082
// module chunks = 25